import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileSizePipe } from './pipes/file-size.pipe';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { MaterialModule } from '../material.module';
import { ObservationsTableComponent } from './components/observations-table/observations-table.component';
import { RouterModule } from '@angular/router';
import { FilesListComponent } from './components/files-list/files-list.component';
import { SharedObservationDetailsComponent } from './components/shared-observation-details/shared-observation-details.component';
import { TranslocoRootModule } from 'app/transloco-root.module';
import { ErrorTemplateComponent } from './components/error-template/error-template.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SearchPipe } from './pipes/search.pipe';
import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { PasswordStrengthBarComponent } from './components/password-strength-bar/password-strength-bar.component';
import { DateTransformPipe } from './pipes/date-transform.pipe';
import { DataTableComponent } from './components/data-table/data-table.component';
import { TranslocoTestingModule } from '@ngneat/transloco';
import { LoadingButtonDirective } from './directives/loading-button.directive';
import { HeaderComponent } from './components/header/header.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RemoveWhitespacesPipe } from './pipes/remove-whitespaces.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { ToolbarBtnComponent } from './components/toolbar-btn/toolbar-btn.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DateStrTransformPipe } from './pipes/date-str-transform.pipe';
import { TrustUrlPipe } from '../modules/Pipes/trustUrl.pipe';
import { RemoveUnderscorePipe } from './pipes/remove-underscore.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { AllActivitiesTodayComponent } from './components/all-activities-today/all-activities-today.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HistoryLogsComponent } from './history-logs/history-logs.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { ViewWeeklyReportComponent } from './components/view-weekly-report/view-weekly-report.component';
import { DashboardHeaderModule } from '../modules/p-dashboard/components/header/dashboard-header.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MatChipsModule } from '@angular/material/chips';
import { CommentsComponent } from './components/comments/comments.component';
import { NgxLoadingModule } from 'ngx-loading';
import { LogsComponent } from './components/logs/logs.component';
import { OptionalLabelPipe } from './pipes/optional-label.pipe';
import { DialogHeaderComponent } from './components/dialog-header/dialog-header.component';
import { DialogFooterComponent } from './components/dialog-footer/dialog-footer.component';
import { SharedProjectsListComponent } from './components/shared-projects-list/shared-projects-list.component';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatOptionModule } from '@angular/material/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UsersSummaryComponent } from './components/users-summary/users-summary.component';
import { LargeNumberPipe } from './pipes/large-numbers.pipe';
import { AddObservationDialogComponent } from './components/add-observation-dialog/add-observation-dialog.component';
import { SortingListComponent } from './components/sorting-list/sorting-list.component';
import { ShareLinkDialogComponent } from './components/share-link-dialog/share-link-dialog.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { NotificationInstructionsDialogComponent } from './components/header/notification-instructions-dialog/notification-instructions-dialog.component';
import { ObservationOnDocumentPopUpComponent } from './components/observation-on-document-pop-up/observation-on-document-pop-up.component';
import { SaveBimOffsetDialogComponent } from './components/save-bim-offset-dialog/save-bim-offset-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { OverlayModule } from '@angular/cdk/overlay';
import { QuillEditorComponent } from 'ngx-quill';
import { PreventScrollPropagationDirective } from './directives/prevent-scroll-propagation.directive';
import { SelectProjectComponent } from './components/select-project/select-project.component';
import { MatSelectModule } from '@angular/material/select';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { Shared360ReportsTableComponent } from './components/shared-360-reports-table/shared-360-reports-table.component';
import { MultiselectLabelsDropdownComponent } from './components/multiselect-labels-dropdown/multiselect-labels-dropdown.component';
import { UserPermissionComponent } from './components/user-permission/user-permission.component';
import { PermissionCheckPipe } from './pipes/permission-check.pipe';
import { MatIconModule } from '@angular/material/icon';
import { ProjectSyncButtonComponent } from './components/project-sync-button/project-sync-button.component';
import { SyncResultsModalComponent } from './components/sync-results-modal/sync-results-modal.component';
import { IntegrationStatusIndicatorComponent } from './components/integration-status-indicator/integration-status-indicator.component';
import { SyncProgressBarComponent } from './components/sync-progress-bar/sync-progress-bar.component';
import { LastSyncResultsButtonModule } from './components/last-sync-results-button/last-sync-results-button.module';
import { CustomFieldRendererComponent } from './components/custom-field-renderer/custom-field-renderer.component';
import { EditableCustomFieldRendererComponent } from './components/editable-custom-field-renderer/editable-custom-field-renderer.component';
import { CustomFieldsSectionComponent } from './components/custom-fields-section/custom-fields-section.component';
import { ObservationsByStatusDialogComponent } from './components/observations-by-status-dialog/observations-by-status-dialog.component';
import { RelatedLogsDialogComponent } from './components/related-logs-dialog/related-logs-dialog.component';
import { CustomFieldLabelPipe } from './pipes/custom-field-label.pipe';
import { FloorPointSizePipe } from './pipes/floor-point-size.pipe';
import { ObservationHashtagsComponent } from './components/observation-hashtags/observation-hashtags.component';
import { HashtagFilterSelectComponent } from './components/hashtag-filter-select/hashtag-filter-select.component';
import { NwcTerminologyPipe } from './pipes/nwc-terminology.pipe';
import { PpeStatusChipComponent } from './components/ppe-status-chip/ppe-status-chip.component';
import { AiBadgeComponent } from './components/ai-badge/ai-badge.component';
import { PpeAiReportActionComponent } from './components/ppe-report-dialog/ppe-ai-report-action/ppe-ai-report-action.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    RouterModule,
    TranslocoRootModule,
    NgxMatDatetimePickerModule,
    TranslocoTestingModule,
    MatProgressBarModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatExpansionModule,
    DashboardHeaderModule,
    NgOptimizedImage,
    MatOptionModule,
    NgApexchartsModule,
    MatChipsModule,
    NgxLoadingModule,
    MatSelectInfiniteScrollModule,
    NgxMatSelectSearchModule,
    InfiniteScrollModule,
    MatCheckboxModule,
    OverlayModule,
    QuillEditorComponent,
    MatSelectModule,
    MatIconModule,
    LastSyncResultsButtonModule,
    PpeAiReportActionComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FileUploaderComponent,
    FileSizePipe,
    ObservationsTableComponent,
    SharedObservationDetailsComponent,
    FilesListComponent,
    TranslocoRootModule,
    ErrorTemplateComponent,
    PasswordStrengthBarComponent,
    DataTableComponent,
    DateTransformPipe,
    LargeNumberPipe,
    LoadingButtonDirective,
    HeaderComponent,
    TimeAgoPipe,
    RemoveWhitespacesPipe,
    ToolbarBtnComponent,
    DateStrTransformPipe,
    TrustUrlPipe,
    RemoveUnderscorePipe,
    TruncatePipe,
    AllActivitiesTodayComponent,
    HistoryLogsComponent,
    CommentsComponent,
    ViewWeeklyReportComponent,
    SharedProjectsListComponent,
    OptionalLabelPipe,
    DialogHeaderComponent,
    DialogFooterComponent,
    UsersSummaryComponent,
    SortingListComponent,
    UserAvatarComponent,
    ShareLinkDialogComponent,
    PreventScrollPropagationDirective,
    SelectProjectComponent,
    LoadingOverlayComponent,
    Shared360ReportsTableComponent,
    MultiselectLabelsDropdownComponent,
    LoadingOverlayComponent,
    UserPermissionComponent,
    PermissionCheckPipe,
    ProjectSyncButtonComponent,
    SyncResultsModalComponent,
    IntegrationStatusIndicatorComponent,
    FloorPointSizePipe,
    SyncProgressBarComponent,
    CustomFieldRendererComponent,
    EditableCustomFieldRendererComponent,
    CustomFieldsSectionComponent,
    ObservationsByStatusDialogComponent,
    RelatedLogsDialogComponent,
    CustomFieldLabelPipe,
    ObservationHashtagsComponent,
    HashtagFilterSelectComponent,
    FloorPointSizePipe,
    NwcTerminologyPipe,
    PpeStatusChipComponent,
    AiBadgeComponent,
    PpeAiReportActionComponent,
  ],
  declarations: [
    FileSizePipe,
    FileUploaderComponent,
    ObservationsTableComponent,
    SharedObservationDetailsComponent,
    FilesListComponent,
    ErrorTemplateComponent,
    ConfirmDialogComponent,
    SearchPipe,
    PasswordStrengthBarComponent,
    DateTransformPipe,
    LargeNumberPipe,
    DataTableComponent,
    LoadingButtonDirective,
    HeaderComponent,
    TimeAgoPipe,
    RemoveWhitespacesPipe,
    ToolbarBtnComponent,
    DateStrTransformPipe,
    TrustUrlPipe,
    RemoveUnderscorePipe,
    TruncatePipe,
    AllActivitiesTodayComponent,
    HistoryLogsComponent,
    MessageDialogComponent,
    ViewWeeklyReportComponent,
    CommentsComponent,
    LogsComponent,
    OptionalLabelPipe,
    DialogHeaderComponent,
    DialogFooterComponent,
    SharedProjectsListComponent,
    UsersSummaryComponent,
    AddObservationDialogComponent,
    SortingListComponent,
    ShareLinkDialogComponent,
    UserAvatarComponent,
    NotificationInstructionsDialogComponent,
    ObservationOnDocumentPopUpComponent,
    SaveBimOffsetDialogComponent,
    PreventScrollPropagationDirective,
    SelectProjectComponent,
    FloorPointSizePipe,
    Shared360ReportsTableComponent,
    MultiselectLabelsDropdownComponent,
    LoadingOverlayComponent,
    ProjectSyncButtonComponent,
    SyncResultsModalComponent,
    IntegrationStatusIndicatorComponent,
    SyncProgressBarComponent,
    UserPermissionComponent,
    CustomFieldRendererComponent,
    EditableCustomFieldRendererComponent,
    CustomFieldsSectionComponent,
    PermissionCheckPipe,
    ObservationsByStatusDialogComponent,
    RelatedLogsDialogComponent,
    CustomFieldLabelPipe,
    ObservationHashtagsComponent,
    HashtagFilterSelectComponent,
    FloorPointSizePipe,
    NwcTerminologyPipe,
    PpeStatusChipComponent,
    AiBadgeComponent,
  ],
})
export class SharedModule {}
